import { useContext } from "react";

import DatePickerRange from "components/DatePickerRange";
import TimeZoneContext from "context/timeZone/timeZoneContext";
import {
    disableDates,
    TIME_LIMIT_SETTINGS,
    useCompanyLevelSettings
} from "shared";

import { ScheduleDateProps } from "./types";

const ScheduleDate = ({
    isLoading,
    startDate,
    endDate,
    selectStartDate,
    selectEndDate
}: ScheduleDateProps) => {
    const { currentTimeZone } = useContext(TimeZoneContext);

    const { getTimeLimit } = useCompanyLevelSettings();

    const taskExpirationTimeLimit = getTimeLimit(
        TIME_LIMIT_SETTINGS.TaskExpirationAfterDays
    );

    const MAX_EXPIRATION_DAYS =
        taskExpirationTimeLimit === -1 ? 360 : taskExpirationTimeLimit;

    return (
        <DatePickerRange
            timezone={currentTimeZone}
            onStartDateSelect={date => selectStartDate(date)}
            onEndDateSelect={date => selectEndDate(date)}
            disablePast
            isRequired
            startDateValue={startDate}
            endDateValue={endDate}
            shouldDisableYear={date =>
                disableDates(date, MAX_EXPIRATION_DAYS, "days", false)
            }
            shouldDisableMonth={date =>
                disableDates(date, MAX_EXPIRATION_DAYS, "days", false)
            }
            shouldDisableDate={date =>
                disableDates(date, MAX_EXPIRATION_DAYS, "days", false)
            }
            readOnly={isLoading}
            inputFieldCustomStyle={{ marginBottom: "16px" }}
        />
    );
};

export default ScheduleDate;
